export default __webpack_public_path__ + "static/media/memory.a5343c13.png";